import { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	getFromSessionStorage,
	SessionStorageKeyTypes,
} from 'utils/clientStorage';
import { useSurveyResultsFilter } from 'hooks/useSurveyResultsFilter';
import { getCurrentMarks } from 'modules/admin-panel/helpers';
import { getMarksAverages } from 'modules/admin-panel/pages/results/helpers/getMarksAverages';
import { COMMENTS_RATING_LEVELS } from 'modules/admin-panel/pages/results/utils';
import { IDashboardReportPayload } from 'modules/admin-panel/pages/results/models';
import { getDashboardReport } from 'modules/admin-panel/pages/results/results.actions';
import {
	activeCommentTypeSelector,
	scaleRangeSelector,
} from 'modules/admin-panel/pages/results/selectors/dashboard.selectors';

export const useDownloadResultReport = () => {
	const dispatch = useDispatch();
	const surveyId = getFromSessionStorage(
		SessionStorageKeyTypes.dashboardSurveyId,
	);
	const activeCommentType = useSelector(activeCommentTypeSelector);
	const scaleRange = useSelector(scaleRangeSelector);
	const {
		surveyFilter,
		surveyFilter: { roundId },
	} = useSurveyResultsFilter();

	const [surveyFilterState, setSurveyFilterState] = useState(surveyFilter);
	useEffect(() => {
		setSurveyFilterState(surveyFilter);
	}, [surveyFilter]);
	if (surveyFilterState.serviceId === '1') {
		setSurveyFilterState({ ...surveyFilter, serviceId: undefined });
	}

	const boundGetDashboardReport = useCallback(
		(p: IDashboardReportPayload) => dispatch(getDashboardReport.default(p)),
		[dispatch],
	);

	return useCallback(() => {
		const marksAverage = getMarksAverages(scaleRange || COMMENTS_RATING_LEVELS);
		boundGetDashboardReport({
			surveyId,
			surveyRoundId: roundId,
			marks: getCurrentMarks(activeCommentType, marksAverage),
			...surveyFilterState,
		});
	}, [
		scaleRange,
		getDashboardReport,
		surveyId,
		roundId,
		activeCommentType,
		surveyFilterState,
	]);
};
